import { Controller } from "@hotwired/stimulus"

// Case d'âge du setup (#2871) : l'âge légal dépend du pays choisi (21 ans aux
// États-Unis, 18 ailleurs). Le serveur rend un texte par âge possible ; ce
// contrôleur n'affiche que celui du pays sélectionné et reporte cet âge dans la
// valeur de la case, que le serveur recoupe avec le pays soumis.
//
// data-age-consent-ages-value='{"US":21}' : âge par pays, data-age-consent-default-value : repli.
export default class extends Controller {
  static targets = ["country", "checkbox", "text"]
  static values = { ages: Object, default: Number }

  connect() {
    this.update()
  }

  update() {
    const age = this.agesValue[this.countryTarget.value] || this.defaultValue
    // Un âge coché pour un pays ne vaut pas pour un autre (18 puis 21 aux États-Unis) :
    // si l'âge change, la case est décochée et l'utilisateur doit la recocher.
    if (Number(this.checkboxTarget.value) !== age && this.checkboxTarget.checked) {
      this.checkboxTarget.checked = false
      this.checkboxTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.checkboxTarget.value = age
    this.textTargets.forEach((el) => { el.hidden = Number(el.dataset.age) !== age })
  }
}
